import { render, staticRenderFns } from "./ModifyPhone.vue?vue&type=template&id=538e36c2&"
import script from "./ModifyPhone.vue?vue&type=script&lang=js&"
export * from "./ModifyPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports